import React, { useEffect, useState } from "react";
import axios from "axios";

const API_URL = "https://zoomautos.co.uk/api/roles"; // Backend API

const RolesManagement = () => {
  const [roles, setRoles] = useState([]);
  const [newRole, setNewRole] = useState("");
  const [editingRole, setEditingRole] = useState(null);
  const [updatedRole, setUpdatedRole] = useState("");

  // Fetch roles from backend
  const token = sessionStorage.getItem("Transport Admin AuthToken");
  useEffect(() => {
    axios.get(API_URL,
      {params: {
        _t: new Date().getTime(), // Add timestamp to bypass cache
      },
    }
    )
      .then(response => setRoles(response.data))
      .catch(error => console.error("Error fetching roles:", error));
  }, []);

  // Add new role
  const addRole = () => {
    if (!newRole) return alert("Role cannot be empty!");
    axios.post(API_URL, { name: newRole },
      {
        headers: { 
          Authorization: `Bearer ${token}` // Attach token
        }
      }
    )
      .then(response => {
        setRoles([...roles, response.data]); 
        setNewRole("");
      })
      .catch(error => console.error("Error adding role:", error));
  };

  // Delete role
  const deleteRole = (id) => {
    axios.delete(`${API_URL}/${id}`, {
      headers: { 
        Authorization: `Bearer ${token}` // Attach token
      }
  })
      .then(() => setRoles(roles.filter(role => role._id !== id)))
      .catch(error => console.error("Error deleting role:", error));
  };

  // Update role
  const updateRole = () => {
    if (!updatedRole) return alert("Updated role cannot be empty!");
    axios.put(`${API_URL}/${editingRole._id}`, 
      { name: updatedRole },
      {
        headers: { 
          Authorization: `Bearer ${token}` // Attach token
        }
      }
    )
      .then(response => {
        setRoles(roles.map(role => role._id === editingRole._id ? response.data : role));
        setEditingRole(null);
        setUpdatedRole("");
      })
      .catch(error => console.error("Error updating role:", error));
  };

  return (
    <div className='overalls'>
                <img
                                          src="/Summary.png"
                                          alt="Logistics Background"
                                          className="background-image2"
                                        />
            
    <div className="review-form" style={{marginBottom:'400px'}}>
      <h2>Roles Management</h2>

      {/* Add Role */}
      <textarea 
        type="text" 
        placeholder="Enter new role" 
        value={newRole} 
        rows={4}
        onChange={(e) => setNewRole(e.target.value)} 
      />
      <button  className="contact-button" onClick={addRole}>Add Role</button>

      {/* Role List */}
      <ul>
        {roles.map(role => (
          <li key={role._id} >
            {editingRole && editingRole._id === role._id ? (
              <>
                <textarea 
                  type="text" 
                  rows={4}
                  value={updatedRole} 
                  onChange={(e) => setUpdatedRole(e.target.value)} 
                />
                <button className="contact-button" onClick={updateRole}>Update</button>
                <button className="contact-button" onClick={() => setEditingRole(null)}>Cancel</button>
              </>
            ) : (
              <>
                <h1  className="specialparagraph3">
          {role.name}
        </h1>
                <button className="contact-button" onClick={() => setEditingRole(role) || setUpdatedRole(role.name)}>Edit</button>
                <button className="contact-button" onClick={() => deleteRole(role._id)}>Delete</button>
              </>
            )}
          </li>
        ))}
      </ul>
    </div>
    </div>
  );
};

export default RolesManagement;
